export default "__VITE_ASSET__CCO12HRk__"